<div data-testid="companies-page" class="companies-page">
  <header class="companies-page__intro">
    <h2 data-testid="companies-title" class="companies-page__title">Company 360</h2>
    <p data-testid="companies-subtitle" class="companies-page__subtitle">Every company with its health, open flags, active users and last login. Open a row for its Company 360.</p>
  </header>
  <section data-testid="companies-card" class="companies">
    <div data-testid="companies-toolbar" class="companies__toolbar">
      <label data-testid="companies-search-box" class="companies__search">
        <i class="fa-regular fa-magnifying-glass companies__search-icon" aria-hidden="true"></i>
        <input type="search" data-testid="companies-search" class="companies__search-input"
               placeholder="Search by company name or id" aria-label="Search companies by name or id"
               [value]="searchText" (input)="onSearch($any($event.target).value)">
      </label>
      <div data-testid="companies-filters" class="companies__filters">
        <div class="companies__filter">
          <span class="companies__filter-label">Health</span>
          <div data-testid="companies-filter-tier" class="adb-segmented" role="radiogroup" aria-label="Health">
            <button *ngFor="let option of tierOptions" type="button" role="radio" class="adb-segmented__option"
                    [attr.data-testid]="'companies-filter-tier-' + option.value" [attr.aria-checked]="params.tier === option.value"
                    (click)="setFilter('tier', option.value)">{{ option.label }}</button>
          </div>
        </div>
        <div class="companies__filter">
          <span class="companies__filter-label">Type</span>
          <div data-testid="companies-filter-kind" class="adb-segmented" role="radiogroup" aria-label="Type">
            <button *ngFor="let option of kindOptions" type="button" role="radio" class="adb-segmented__option"
                    [attr.data-testid]="'companies-filter-kind-' + option.value" [attr.aria-checked]="params.kind === option.value"
                    (click)="setFilter('kind', option.value)">{{ option.label }}</button>
          </div>
        </div>
        <div class="companies__filter">
          <span class="companies__filter-label">Status</span>
          <div data-testid="companies-filter-status" class="adb-segmented" role="radiogroup" aria-label="Status">
            <button *ngFor="let option of statusOptions" type="button" role="radio" class="adb-segmented__option"
                    [attr.data-testid]="'companies-filter-status-' + option.value" [attr.aria-checked]="params.status === option.value"
                    (click)="setFilter('status', option.value)">{{ option.label }}</button>
          </div>
        </div>
        <button type="button" data-testid="companies-filter-flagged" class="companies__flagged" [attr.aria-pressed]="params.flagged"
                (click)="setFilter('flagged', !params.flagged)">
          <i class="fa-regular fa-flag" aria-hidden="true"></i>Has open flags
        </button>
      </div>
    </div>
    <p *ngIf="!loaded" data-testid="companies-loading" class="companies__muted">Loading companies…</p>
    <ng-container *ngIf="loaded">
      <p *ngIf="!failed" data-testid="companies-summary" class="companies__summary">
        <span data-testid="companies-total">{{ totalText }}</span> · <span data-testid="companies-asof">{{ asOfText }}</span>
      </p>
      <app-admin-dashboard-empty *ngIf="failed" data-testid="companies-failed" icon="fa-regular fa-circle-exclamation"
                                 [title]="failedTitle" body="Try again in a moment.">
        <button type="button" data-testid="companies-retry" class="companies__retry" (click)="load()">Try again</button>
      </app-admin-dashboard-empty>
      <app-admin-dashboard-empty *ngIf="!failed && !rows.length" data-testid="companies-empty" icon="fa-regular fa-building"
                                 [title]="'No companies match'" body="Clear the search or the filters to see more."></app-admin-dashboard-empty>
      <div *ngIf="!failed && rows.length" class="companies__table-wrap" [class.companies__table-wrap--loading]="loading"
           [attr.aria-busy]="loading">
        <table data-testid="companies-table" class="companies__table">
          <thead>
            <tr>
              <th data-testid="companies-th-name" [attr.aria-sort]="ariaSort('name')">
                <button type="button" data-testid="companies-sort-name" class="companies__sort" (click)="sortBy('name')">Company<i
                  class="fa-solid companies__sort-icon" [ngClass]="sortIcon('name')" aria-hidden="true"></i></button>
              </th>
              <th>Type</th>
              <th data-testid="companies-th-health" [attr.aria-sort]="ariaSort('health')">
                <button type="button" data-testid="companies-sort-health" class="companies__sort" (click)="sortBy('health')">Health<i
                  class="fa-solid companies__sort-icon" [ngClass]="sortIcon('health')" aria-hidden="true"></i></button>
              </th>
              <th>Open flags</th>
              <th data-testid="companies-th-activeUsers" class="companies__number" [attr.aria-sort]="ariaSort('activeUsers')">
                <button type="button" data-testid="companies-sort-activeUsers" class="companies__sort" (click)="sortBy('activeUsers')">Active users<i
                  class="fa-solid companies__sort-icon" [ngClass]="sortIcon('activeUsers')" aria-hidden="true"></i></button>
              </th>
              <th data-testid="companies-th-lastLogin" [attr.aria-sort]="ariaSort('lastLogin')">
                <button type="button" data-testid="companies-sort-lastLogin" class="companies__sort" (click)="sortBy('lastLogin')">Last login<i
                  class="fa-solid companies__sort-icon" [ngClass]="sortIcon('lastLogin')" aria-hidden="true"></i></button>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let row of rows" data-testid="companies-row" class="companies__row" tabindex="0"
                (click)="open(row)" (keydown.enter)="open(row)">
              <td class="companies__company">
                <span data-testid="companies-name" class="companies__name">{{ row.companyName }}</span>
                <span data-testid="companies-id" class="companies__id">{{ row.companyId }}</span>
                <span *ngIf="!row.isActive" data-testid="companies-inactive" class="companies__inactive">Inactive</span>
              </td>
              <td>
                <span data-testid="companies-type" class="companies__type"
                      [class.companies__type--client]="row.isClient">{{ row.isClient ? 'Client' : 'Not in Client Manager' }}</span>
              </td>
              <td>
                <span *ngIf="row.tier; else unscored" class="companies__health">
                  <span data-testid="companies-tier" class="adb-tier-badge companies__tier" [attr.data-tier]="row.tier"
                        [ngClass]="'tier-' + row.tier">{{ tierLabel(row.tier) }}</span>
                  <span data-testid="companies-score" class="companies__score">{{ row.healthScore }}</span>
                </span>
                <ng-template #unscored><span data-testid="companies-unscored" class="companies__unscored">Unscored</span></ng-template>
              </td>
              <td>
                <span *ngIf="row.openFlags.length; else noFlags" class="companies__flags">
                  <span *ngFor="let flag of row.openFlags" data-testid="companies-flag" class="companies__flag">
                    <i class="fa-regular" [ngClass]="flagIcon(flag.kind)" aria-hidden="true"></i>{{ flag.label }}
                  </span>
                </span>
                <ng-template #noFlags><span data-testid="companies-no-flags" class="companies__none">—</span></ng-template>
              </td>
              <td data-testid="companies-active-users" class="companies__number">{{ row.activeUsers == null ? '—' : (row.activeUsers | number) }}</td>
              <td data-testid="companies-last-login">{{ row.lastLogin ? (row.lastLogin | date:'d MMM y':'UTC') : 'Never' }}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <footer *ngIf="!failed && rows.length" data-testid="companies-pager" class="companies__pager">
        <span data-testid="companies-range" class="companies__range">{{ rangeText }}</span>
        <span class="companies__pager-buttons">
          <button type="button" data-testid="companies-previous" class="companies__page-button" [disabled]="!hasPrevious"
                  (click)="goToPage(page - 1)"><i class="fa-regular fa-angle-left" aria-hidden="true"></i>Previous</button>
          <button type="button" data-testid="companies-next" class="companies__page-button" [disabled]="!hasNext"
                  (click)="goToPage(page + 1)">Next<i class="fa-regular fa-angle-right" aria-hidden="true"></i></button>
        </span>
      </footer>
    </ng-container>
  </section>
</div>
